import styled from "styled-components";

import {
  SEMI_BOLD_FONT,
  QUERY_IPAD,
  QUERY_IPHONE_6_7_8_PLUS,
} from "@shared/constants";

export const StyledBioSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 200px 32px;

  .content {
    max-width: 1000px;
    display: grid;
    gap: 60px;
    grid-template-columns: 4fr 2fr;
  }

  .info {
    .heading {
      font-size: 32px;
      margin-bottom: 28px;
    }

    .paragraph {
      font-size: 16px;
      margin-bottom: 8px;

      span {
        white-space: nowrap;
      }
    }

    .terminal {
      margin-top: 56px;
      border-radius: 16px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04);
      overflow: hidden;

      &-head {
        display: flex;
        align-items: center;
        background-color: rgb(58, 58, 61);
        padding: 10px;
        position: relative;

        .dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          margin-right: 8px;
        }

        .dot-1 {
          background-color: rgb(238, 101, 90);
        }

        .dot-2 {
          background-color: rgb(255, 192, 76);
        }

        .dot-3 {
          background-color: rgb(113, 189, 70);
        }

        .name {
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          font-weight: ${SEMI_BOLD_FONT};
          white-space: nowrap;
          display: flex;
          align-items: center;
          font-size: 15px;

          span {
            margin-left: 8px;
            color: rgb(185, 186, 189);
          }
        }
      }

      &-content {
        background-color: rgb(30, 30, 30);
        padding: 16px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        row-gap: 36px;

        span {
          margin-left: 12px;
          position: relative;
          display: flex;
          color: #ffffff;

          &::after {
            content: '*';
            position: absolute;
            top: 3px;
            left: -12px;
            color: #ffffff;
          }
        }
      }
    }
  }

  .photo {    
    img {
      border-radius: 16px;
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }

  @media (max-width: ${QUERY_IPAD}px) {
    padding: 140px 32px;

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .info {
        .heading {
          margin-bottom: 48px;
        }
      }
    }

    .photo {
      margin-top: 56px;
      max-width: 300px;
      width: 100%;
    }
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8_PLUS}px) {
    padding: 100px 24px;

    .info {
      .heading {
        font-size: 28px;
      }

      .terminal {
        &-head {
          .name {
            font-size: 14px;
            left: 55%;
          }
        }
      }
    }

    .photo {
      max-width: 200px;
    }
  }
`;
